import { SessionKit } from '@wharfkit/session';
import { WebRenderer } from '@wharfkit/web-renderer';
import { WalletPluginAnchor } from '@wharfkit/wallet-plugin-anchor';
import { WalletPluginCloudWallet } from '@wharfkit/wallet-plugin-cloudwallet';

export const WAX_CHAIN = {
  id: '1064487b3cd1a897ce03ae5b6a865651747e2e152090f99c1d19d44e01aea5a4',
  url: 'https://wax.greymass.com',
};

// Singleton — one kit shared across the whole app
let kitInstance: SessionKit | null = null;

export function getSessionKit(): SessionKit {
  if (!kitInstance) {
    kitInstance = new SessionKit({
      appName: 'Samatvam',
      chains: [{ id: WAX_CHAIN.id, url: WAX_CHAIN.url }],
      ui: new WebRenderer(),
      walletPlugins: [
        new WalletPluginCloudWallet(),
        new WalletPluginAnchor(),
      ],
    });
  }
  return kitInstance;
}
